import React from 'react'
import styled from 'styled-components'
import LogoShort from 'assets/images/bp-logo-orange.png'
import LogoFull from 'assets/images/bp-logo.png'
import { PATHS, PRIVATE_PATHS, redirect } from 'utils/paths'

const Logo = ({ isloggedin, small }) => {
  return isloggedin ? (
    <ShortLogoWrapper $small={small} onClick={() => redirect(PRIVATE_PATHS.dashboard)}>
      <img src={LogoShort} alt='company logo' />
    </ShortLogoWrapper>
  ) : (
    <LogoWrapper onClick={() => redirect(PATHS.home)}>
      <img src={LogoFull} alt='company logo' />
    </LogoWrapper>
  )
}

export default Logo

const ShortLogoWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  /* The compact variant lives in the 60px mobile bar, so it must not inherit
     the desktop top bar's height or the navigation column's width. */
  min-width: ${({ theme, $small }) => $small ? 'auto' : theme.dimensions.navWidth};
  height: ${({ theme, $small }) => $small ? 'auto' : theme.dimensions.topBarHeight};
  flex-shrink: 0;

  img {
    height: 34px;
    width: auto;
    cursor: pointer;
    max-width: 100%;
  }

  @media (max-width: 992px) {
    min-width: auto;
    padding: ${({ $small }) => $small ? '0' : '0 16px'};

    img {
      height: 30px;
    }
  }

  @media (max-width: 576px) {
    padding: ${({ $small }) => $small ? '0' : '0 12px'};

    img {
      height: 26px;
    }
  }
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  max-width: 250px;
  width: 100%;

  img {
    cursor: pointer;
    display: block;
    width: 100%;
    height: auto;
    max-width: clamp(140px, 40vw, 250px);
  }

  /* Tablet */
  @media (max-width: 992px) {
    padding: 16px;
    max-width: 220px;

    img {
      max-width: clamp(130px, 45vw, 220px);
    }
  }

  /* Mobile */
  @media (max-width: 576px) {
    padding: 12px;
    max-width: 200px;

    img {
      max-width: clamp(120px, 55vw, 200px);
    }
  }
`
